import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const BookTheme = pgTable(
  'book_theme',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    slug: text().notNull(),
    description: text(),
    iconUrl: text().notNull(),
    order: integer().notNull(),
    legacyThemeId: integer(),
    legacyNeonBookThemeId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('book_theme_name_idx').on(columns.name),
    index('book_theme_slug_idx').on(columns.slug),
    index('book_theme_order_idx').on(columns.order),
    index('book_theme_updated_at_idx').on(columns.updatedAt),
    index('book_theme_created_at_idx').on(columns.createdAt),
    index('book_theme_legacy_neon_book_theme_id_idx').on(columns.legacyNeonBookThemeId),
  ],
)

export const InsertBookThemeSchema = createInsertSchema(BookTheme)
export const UpdateBookThemeSchema = createUpdateSchema(BookTheme)
  .omit({ id: true, legacyThemeId: true, legacyNeonBookThemeId: true })
  .partial()
export const SelectBookThemeSchema = createSelectSchema(BookTheme)

export type InsertBookTheme = typeof BookTheme.$inferInsert
export type UpdateBookTheme = z.infer<typeof UpdateBookThemeSchema>
export type SelectBookTheme = typeof BookTheme.$inferSelect
